import React, { useState } from 'react';
import { IconButton, Menu, MenuItem, ListItemIcon, ListItemText, useTheme } from '@mui/material';
import { MoreVert as MoreVertIcon } from '@mui/icons-material';
import useRolePermissions from '../../../shared/hooks/useRolePermissions';
import { ROLES_ROUTE } from '../../../shared/constants/constant-data';

interface AgentActionMenuProps {
  params: any;
  onEdit: (agent: any) => void;
  onPause: (agent: any) => void;
  onResume: (agent: any) => void;
  onUnenroll: (agent: any) => void;
  onLinkedScans: (agent: any) => void;
}

const AgentActionMenu: React.FC<AgentActionMenuProps> = ({
  params,
  onEdit,
  onPause,
  onResume,
  onUnenroll,
  onLinkedScans,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';
  const { hasPermissions } = useRolePermissions();

  const canEdit = hasPermissions("create_edit_agents_new") || hasPermissions("create_edit_agent_new");
  const canPauseUnenroll = hasPermissions("pause_unenroll_agent_new");

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const agent = params.data;
  const isPaused = agent.status_display === 'Paused';
  const isActive = agent.status_display === 'Active';
  const isInactive = agent.status_display === 'Inactive';
  const isPending = agent.status_display === 'Pending';
  const isUnenrolled = agent.status_display === 'Unenrolled';

  const handleAction = (callback: (agent: any) => void) => (event: React.MouseEvent) => {
    event.stopPropagation();
    callback(agent);
    handleClose();
  };

  return (
    <div onClick={(e) => e.stopPropagation()}>
      <IconButton
        size="small"
        onClick={handleClick}
        sx={{ color: isDarkMode ? '#9CA3AF' : '#666' }}
      >
        <MoreVertIcon fontSize="small" />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          sx: {
            minWidth: 140,
            boxShadow: '0px 4px 20px rgba(0,0,0,0.1)',
            borderRadius: '10px',
            mt: 1,
            '& .MuiMenuItem-root': {
              fontSize: '13px',
              py: 1,
              px: 2,
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        {isUnenrolled ? (
          <MenuItem onClick={handleAction(onLinkedScans)}>
            <ListItemIcon sx={{ minWidth: '20px !important' }}>
              {/* <LinkIcon fontSize="small" sx={{ color: '#3A2ADA' }} /> */}
            </ListItemIcon>
            <ListItemText primary="Linked Scans" />
          </MenuItem>
        ) : isInactive ? (
          <>
            <MenuItem onClick={handleAction(onLinkedScans)}>
              <ListItemIcon sx={{ minWidth: '20px !important' }}>
                {/* <LinkIcon fontSize="small" sx={{ color: '#3A2ADA' }} /> */}
              </ListItemIcon>
              <ListItemText primary="Linked Scans" />
            </MenuItem>
          </>
        ) : isPending ? (
          canEdit ? (
            <MenuItem onClick={handleAction(onEdit)}>
              <ListItemIcon sx={{ minWidth: '20px !important' }}>
                {/* <EditIcon fontSize="small" sx={{ color: '#4640DE' }} /> */}
              </ListItemIcon>
              <ListItemText primary="Edit" />
            </MenuItem>
          ) : null
        ) : (
          <>
            {canEdit && (
              <MenuItem onClick={handleAction(onEdit)}>
                <ListItemIcon sx={{ minWidth: '32px !important' }}>
                  {/* <EditIcon fontSize="small" sx={{ color: '#4640DE' }} /> */}
                </ListItemIcon>
                <ListItemText primary="Edit" />
              </MenuItem>
            )}
            <MenuItem onClick={handleAction(onLinkedScans)}>
              <ListItemIcon sx={{ minWidth: '32px !important' }}>
                {/* <LinkIcon fontSize="small" sx={{ color: '#3A2ADA' }} /> */}
              </ListItemIcon>
              <ListItemText primary="Linked Scans" />
            </MenuItem>

            {isActive && canPauseUnenroll && (
              <MenuItem onClick={handleAction(onPause)}>
                <ListItemIcon sx={{ minWidth: '32px !important' }}>
                  {/* <PauseIcon fontSize="small" sx={{ color: '#F7941F' }} /> */}
                </ListItemIcon>
                <ListItemText primary="Pause" />
              </MenuItem>
            )}

            {isPaused && canPauseUnenroll && (
              <MenuItem onClick={handleAction(onResume)}>
                <ListItemIcon sx={{ minWidth: '32px !important' }}>
                  {/* <PlayArrowIcon fontSize="small" sx={{ color: '#22C55E' }} /> */}
                </ListItemIcon>
                <ListItemText primary="Resume" />
              </MenuItem>
            )}
            {canPauseUnenroll && (
              <MenuItem onClick={handleAction(onUnenroll)}>
                <ListItemIcon sx={{ minWidth: '32px !important' }}>
                  {/* <PersonOffIcon fontSize="small" sx={{ color: '#DC3545' }} /> */}
                </ListItemIcon>
                <ListItemText primary="Unenroll Agent" />
              </MenuItem>
            )}


          </>
        )}

        {/* <MenuItem onClick={handleAction(onAddScan)}>
          <ListItemIcon sx={{ minWidth: '32px !important' }}>
            <AddIcon fontSize="small" sx={{ color: '#4640DE' }} />
          </ListItemIcon>
          <ListItemText primary="Add Scan" />
        </MenuItem> */}
      </Menu>
    </div>
  );
};

export default AgentActionMenu;
